<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="identity">Identity</div>
      <div>
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [technician]="technicianName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [comments]="comments"
          [technicianId]="technicianId"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container site-container">
      <div class="endpoints"><label>Endpoints</label></div>
      <div class="endpoint-section">
        <nrwl-agent-picker
          [testType]="'truespeed'"
          [originatorDevice]="selectedOriginator"
          [destinationDevice]="selectedDestination"
          [editMode]="editMode"
          [testMode]="testMode"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
        <div class="agent-info">
          <div class="orginator-info">
            <div class="orginator-content" *ngIf="showOrginatorDetails">
              <div
                class="section-data"
                *ngIf="
                  showFormField(configMapping.SRC_TRANSMIT_INTERFACE) &&
                  srcAgentType === agentModel.JMEP_10G
                "
              >
                <div class="group">
                  <div class="label">Transmit interface</div>
                  <mat-select
                    class="option-list"
                    #txInterfaceInput="ngModel"
                    [(ngModel)]="formField.txInterface"
                    name="txInterface"
                    (selectionChange)="onTxInterfaceChange()"
                    required
                  >
                    <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                      tx.name
                    }}</mat-option>
                  </mat-select>
                </div>
                <div class="tx-image" *ngIf="showFormField(configMapping.SRC_TRANSMIT_INTERFACE)">
                  <img [src]="txTypeImage" />
                </div>
                <div
                  class="group"
                  *ngIf="
                    showFormField(configMapping.SRC_MAC_ADDRESS) ||
                    showFormField(configMapping.SRC_EQUIPMENT_MAC)
                  "
                >
                  <div class="label">MAC address *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcMacAddress"
                    [(ngModel)]="formField.srcMacAddress"
                    #srcMacAddressInput="ngModel"
                    (ngModelChange)="onSourceMacAddressChange()"
                    [pattern]="macRegex"
                    [disabled]="true"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcMacAddressInput.invalid &&
                      (srcMacAddressInput.dirty || srcMacAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcMacAddressInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcMacAddressInput.errors?.pattern"
                      >Mac Address is not a valid</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="section-data" *ngIf="showFormField(configMapping.SRC_TEST_IP_ADDRESS)">
                <div
                  class="group"
                  *ngIf="
                    showFormField(configMapping.SRC_DEFINED_ADDRESS) &&
                    srcAgentType === agentModel.JMEP_10G
                  "
                >
                  <div class="label">Defined address using</div>
                  <mat-select
                    class="option-list"
                    #definedAddressInput="ngModel"
                    [(ngModel)]="formField.definedAddress"
                    name="definedAddress"
                    (selectionChange)="onDefinedAddressChange()"
                    required
                  >
                    <ng-container *ngFor="let type of srcDefinedAddressTypes">
                      <mat-option *ngIf="type.enabled" [value]="type.value">{{
                        type.name
                      }}</mat-option>
                    </ng-container>
                  </mat-select>
                </div>
                <div class="group">
                  <div class="label">IP address *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcIpAddress"
                    class="width-200"
                    [(ngModel)]="formField.srcIpAddress"
                    #srcIpAddressInput="ngModel"
                    (ngModelChange)="onSourceIpAddressChange()"
                    [pattern]="validIPRegex"
                    [disabled]="true"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcIpAddressInput.invalid &&
                      (srcIpAddressInput.dirty || srcIpAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcIpAddressInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcIpAddressInput?.errors?.pattern"
                      >Address is not a valid IPv4 or IPv6 address</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="section-data" *ngIf="showFormField(configMapping.SRC_SUBNET)">
                <div class="group">
                  <div class="label">Subnet mask/prefix</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcSubnet"
                    [(ngModel)]="formField.srcSubnet"
                    #srcSubnetInput="ngModel"
                    (ngModelChange)="onSourceSubnetChange()"
                    [pattern]="subnetRegEx"
                    [disabled]="formField.definedAddress === addressTypeValue.TEST_IP"
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcSubnetInput.invalid && (srcSubnetInput.dirty || srcSubnetInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcSubnetInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcSubnetInput.errors?.pattern"
                      >Subnet is not valid</mat-error
                    >
                  </div>
                </div>
                <div class="group" *ngIf="showFormField(configMapping.SRC_GATEWAY)">
                  <div class="label">Gateway address</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcGateway"
                    [(ngModel)]="formField.srcGateway"
                    #srcGatewayInput="ngModel"
                    (ngModelChange)="onSourceGatewayChange()"
                    [pattern]="validIPRegex"
                    [disabled]="formField.definedAddress === addressTypeValue.TEST_IP"
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcGatewayInput.invalid && (srcGatewayInput.dirty || srcGatewayInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcGatewayInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcGatewayInput.errors?.pattern">
                      Gateway must be set to a valid address
                    </mat-error>
                  </div>
                </div>
              </div>
              <div
                class="section-data"
                *ngIf="
                  showFormField(configMapping.SRC_VLAN_ID) &&
                  srcAgentType === agentModel.JMEP_10G &&
                  formField.definedAddress === addressTypeValue.TEST_IP
                "
              >
                <div class="group">
                  <div class="label-container">
                    <label class="label">VLAN *</label>
                  </div>
                  <input
                    matInput
                    autocomplete="off"
                    type="number"
                    class="input-data"
                    name="srcVlanID"
                    [(ngModel)]="formField.srcVlanID"
                    (ngModelChange)="onSrcVlanIdChange()"
                    #srcVlanIDInput="ngModel"
                    [disabled]="true"
                    min="1"
                    max="4095"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcVlanIDInput.invalid && (srcVlanIDInput.dirty || srcVlanIDInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcVlanIDInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcVlanIDInput.errors?.min || srcVlanIDInput.errors?.max">
                      Enter value between 1 - 4095
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="destination-info" *ngIf="showDestinationDetails">
            <div
              class="section-data"
              *ngIf="
                showFormField(configMapping.DEST_TRANSMIT_INTERFACE) &&
                destAgentType === agentModel.JMEP_10G
              "
            >
              <div class="group">
                <div class="label">Transmit interface</div>
                <mat-select
                  class="option-list"
                  #destTxInterfaceInput="ngModel"
                  [(ngModel)]="formField.destTxInterface"
                  name="destTxInterface"
                  (selectionChange)="onDestTxInterfaceChange()"
                  required
                >
                  <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                    tx.name
                  }}</mat-option>
                </mat-select>
              </div>
              <div
                class="tx-image"
                *ngIf="
                  showFormField(configMapping.DEST_TRANSMIT_INTERFACE) &&
                  destAgentType === agentModel.JMEP_10G
                "
              >
                <img [src]="destTxTypeImage" />
              </div>
              <div
                class="group"
                *ngIf="
                  destAgentType === agentModel.JMEP_10G &&
                  (showFormField(configMapping.DEST_MAC_ADDRESS) ||
                    showFormField(configMapping.DEST_EQUIPMENT_MAC))
                "
              >
                <div class="label">MAC address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="destMacAddress"
                  [(ngModel)]="formField.destMacAddress"
                  #destMacAddressInput="ngModel"
                  (ngModelChange)="onDestinationMacAddressChange()"
                  [pattern]="macRegex"
                  [disabled]="true"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destMacAddressInput.invalid &&
                    (destMacAddressInput.dirty || destMacAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destMacAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destMacAddressInput?.errors?.pattern"
                    >Mac Address is not a valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-data">
              <div
                class="group"
                *ngIf="
                  showFormField(configMapping.DEST_DEFINED_ADDRESS) &&
                  destAgentType === agentModel.JMEP_10G
                "
              >
                <div class="label">Defined address using</div>
                <mat-select
                  class="option-list"
                  #destDefinedAddressInput="ngModel"
                  [(ngModel)]="formField.destDefinedAddress"
                  name="destDefinedAddress"
                  (selectionChange)="onDestDefinedAddressChange()"
                  required
                >
                  <ng-container *ngFor="let type of destDefinedAddressTypes">
                    <mat-option *ngIf="type.enabled" [value]="type.value">{{
                      type.name
                    }}</mat-option>
                  </ng-container>
                </mat-select>
              </div>
              <div class="group" *ngIf="showFormField(configMapping.DEST_TEST_IP_ADDRESS)">
                <div class="label">IP address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  class="width-200"
                  name="destIpAddress"
                  [(ngModel)]="formField.destIpAddress"
                  #destIpAddressInput="ngModel"
                  (ngModelChange)="onDestinationIpAddressChange()"
                  [pattern]="validIPRegex"
                  [disabled]="true"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destIpAddressInput.invalid &&
                    (destIpAddressInput.dirty || destIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destIpAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destIpAddressInput.errors?.pattern"
                    >Address is not a valid IPv4 or IPv6 address</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group" *ngIf="showFormField(configMapping.DEST_SUBNET)">
                <div class="label">Subnet mask/prefix</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="destSubnet"
                  [(ngModel)]="formField.destSubnet"
                  #destSubnetInput="ngModel"
                  (ngModelChange)="onDestinationSubnetChange()"
                  [pattern]="subnetRegEx"
                  [disabled]="formField.destDefinedAddress === addressTypeValue.TEST_IP"
                />
                <div
                  class="error"
                  *ngIf="
                    destSubnetInput.invalid && (destSubnetInput.dirty || destSubnetInput.touched)
                  "
                >
                  <mat-error *ngIf="destSubnetInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destSubnetInput.errors?.pattern">Subnet is not valid</mat-error>
                </div>
              </div>
              <div class="group" *ngIf="showFormField(configMapping.DEST_GATEWAY)">
                <div class="label">Gateway address</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="destGateway"
                  [(ngModel)]="formField.destGateway"
                  #destGatewayInput="ngModel"
                  (ngModelChange)="onDestinationGatewayChange()"
                  [pattern]="validIPRegex"
                  [disabled]="formField.destDefinedAddress === addressTypeValue.TEST_IP"
                />
                <div
                  class="error"
                  *ngIf="
                    destGatewayInput.invalid && (destGatewayInput.dirty || destGatewayInput.touched)
                  "
                >
                  <mat-error *ngIf="destGatewayInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destGatewayInput.errors?.pattern"
                    >Gateway must be set to a valid address</mat-error
                  >
                </div>
              </div>
              <div class="group" *ngIf="showFormField(configMapping.SUPPRESS_LOOP_COMMANDS)">
                <div class="label">Loop up device</div>
                <mat-select
                  class="option-list width-75"
                  #supressLoopIntervalInput="ngModel"
                  [(ngModel)]="formField.suppressLoop"
                  name="suppressLoop"
                  (selectionChange)="onSuppressLoopChange()"
                  required
                >
                  <mat-option *ngFor="let supress of suppressLoopTypes" [value]="supress.value">{{
                    supress.name
                  }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div
              class="section-data"
              *ngIf="
                showFormField(configMapping.DEST_VLAN_ID) &&
                destAgentType === agentModel.JMEP_10G &&
                formField.destDefinedAddress === addressTypeValue.TEST_IP
              "
            >
              <div class="group">
                <div class="label-container">
                  <label class="label">VLAN *</label>
                </div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  class="input-data"
                  name="destVlanID"
                  [(ngModel)]="formField.destVlanID"
                  (ngModelChange)="onSrcVlanIdChange()"
                  #destVlanIDInput="ngModel"
                  min="1"
                  max="4095"
                  required
                  [disabled]="true"
                />
                <div
                  class="error"
                  *ngIf="
                    destVlanIDInput.invalid && (destVlanIDInput.dirty || destVlanIDInput.touched)
                  "
                >
                  <mat-error *ngIf="destVlanIDInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destVlanIDInput.errors?.min || destVlanIDInput.errors?.max">
                    Enter value between 1 - 4095
                  </mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!isDisabledScheduler">
      <div class="section-container" *ngIf="!showExpirationField">
        <div class="schedule"><label>Schedule</label></div>
        <div class="scheduler-section">
          <div class="scheduler-section">
            <viavi-scheduler
              [scheduleValue]="scheduleInfoData"
              (schedulerDataVal)="fetchSchedulerVal($event)"
              [isDisabledScheduler]="isDisabledScheduler"
              [schedulerEnds]="schedulerEndOptions"
            >
            </viavi-scheduler>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="section-container">
      <div class="CIR_test"><label>Threshold</label></div>
      <div class="group stream-data">
        <div class="label-container">
          <label class="label">Threshold (%) *</label>
        </div>
        <input
          matInput
          autocomplete="off"
          type="number"
          class="input-data"
          name="threshold"
          [(ngModel)]="formField.threshold"
          #thresholdInput="ngModel"
          (ngModelChange)="thresholdUpdated()"
          [disabled]="!isThresholdOverridable"
          [ngClass]="{ disable: !isThresholdOverridable }"
          min="1"
          max="100"
          [pattern]="noDecimalPattern"
          required
        />
        <div
          class="error"
          *ngIf="thresholdInput.invalid && (thresholdInput.dirty || thresholdInput.touched)"
        >
          <mat-error *ngIf="thresholdInput?.errors?.required">required</mat-error>
          <mat-error
            *ngIf="
              thresholdInput.errors?.min ||
              thresholdInput.errors?.max ||
              thresholdInput?.errors?.pattern
            "
          >
            Value should be 1 to 100
          </mat-error>
        </div>
      </div>
    </div>
    <div class="section-container threshold-section">
      <div class="CIR_test"><label>CIR to Test</label></div>
      <div class="group stream-data">
        <div class="label-container" *ngIf="isAgentToJmep">
          <label class="label">CIR (Mbps) *</label>
        </div>
        <div class="label-container width-150" *ngIf="!isAgentToJmep">
          <label class="label">Downstream (Mbps) *</label>
        </div>
        <input
          matInput
          autocomplete="off"
          type="number"
          class="input-data"
          name="downstream"
          [(ngModel)]="formField.downstream"
          #downstreamInput="ngModel"
          (ngModelChange)="downstreamUpdated()"
          [disabled]="disableSteamInputs"
          [ngClass]="{ disable: disableSteamInputs }"
          min="1"
          required
        />
        <div
          class="error"
          *ngIf="
            (downstreamInput.invalid && (downstreamInput.dirty || downstreamInput.touched)) ||
            !validityStreamCheck(formField.downstream, setupService.maxDownStream)
          "
        >
          <mat-error
            *ngIf="
              formField.downstream &&
              !validityStreamCheck(formField.downstream, setupService.maxDownStream) &&
              !downstreamInput?.errors?.required
            "
            >Downstream should be {{ minCir }} to {{ setupService.maxDownStream }}</mat-error
          >
          <mat-error *ngIf="downstreamInput?.errors?.required">required</mat-error>
        </div>
      </div>
      <div class="group stream-data field-margin" *ngIf="!isAgentToJmep">
        <div class="label-container"><label class="label">Upstream (Mbps) *</label></div>
        <input
          matInput
          autocomplete="off"
          type="number"
          class="input-data"
          name="upstream"
          [disabled]="disableSteamInputs"
          [ngClass]="{ disable: disableSteamInputs }"
          [(ngModel)]="formField.upstream"
          #upstreamInput="ngModel"
          (ngModelChange)="upstreamUpdated()"
          min="1"
          required
        />
        <div
          class="error"
          *ngIf="
            (upstreamInput.invalid && (upstreamInput.dirty || upstreamInput.touched)) ||
            !validityStreamCheck(formField.upstream, setupService.maxUpStream)
          "
        >
          <mat-error
            *ngIf="
              formField.upstream &&
              !validityStreamCheck(formField.upstream, setupService.maxUpStream) &&
              !upstreamInput?.errors?.required
            "
            >Upstream should be 1 to {{ setupService.maxUpStream }}</mat-error
          >
          <mat-error *ngIf="upstreamInput?.errors?.required"> required</mat-error>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="CIR_test"><label></label></div>
      <div class="group stream-data">
        <div class="label-container" *ngIf="isAgentToJmep">
          <label class="label">Target CIR (Mbps)</label>
        </div>
        <div class="label-container width-150" *ngIf="!isAgentToJmep">
          <label class="label">Target Downstream (Mbps)</label>
        </div>
        <input
          matInput
          autocomplete="off"
          type="number"
          class="input-data disable"
          name="downstreamThreshold"
          [(ngModel)]="formField.downstreamThreshold"
          #downstreamThresholdInput="ngModel"
          disabled="true"
          required
        />
      </div>
      <div class="group stream-data field-margin" *ngIf="!isAgentToJmep">
        <div class="label-container"><label class="label">Target Upstream (Mbps)</label></div>
        <input
          matInput
          autocomplete="off"
          type="number"
          class="input-data disable"
          name="upstreamThreshold"
          [(ngModel)]="formField.upstreamThreshold"
          #upstreamThresholdInput="ngModel"
          disabled="true"
          required
        />
      </div>
    </div>
    <div class="section-container" *ngIf="showExpirationField">
      <div class="schedule"><label>Schedule</label></div>
      <div class="group">
        <div class="label-container"><label class="label">Expiration Time (UTC)</label></div>
        <mat-select
          [disabled]="!expirationTimeOverwrite"
          class="option-list"
          #expireTimeInput="ngModel"
          [(ngModel)]="formField.expirationTime"
          name="expireTime"
          (selectionChange)="onExpireTimeChange($event)"
          required
        >
          <mat-option *ngFor="let time of expireTimeData" [value]="time.value">{{
            time.name
          }}</mat-option>
        </mat-select>
      </div>
      <div class="group max-execution-counts">
        <div class="label-container">
          <label class="label"
            >Max Execution Counts<i
              class="mdi mdi-help-circle-outline"
              matTooltip="{{ formTooltip.maxExecutionCounts }}"
            ></i
          ></label>
        </div>
        <input
          [disabled]="!executionCountsOverwrite"
          matInput
          autocomplete="off"
          type="number"
          class="input-small"
          name="executionCount"
          [(ngModel)]="formField.executionCounts"
          #executionCountInput="ngModel"
          placeholder="Unlimited"
          (ngModelChange)="onExecutionCountUpdated()"
          min="0"
          [max]="maxExecutionCountValue"
        />
        <mat-error *ngIf="executionCountInput.errors?.min || executionCountInput.errors?.max">
          value should be 0 to
          {{ maxExecutionCountValue }}</mat-error
        >
      </div>
    </div>
    <div
      class="section-container"
      *ngIf="
        setupService.clientToAgentInfo.secondaryTestURL !== null ||
        setupService.clientToAgentInfo.dmzServerUrl !== null
      "
    >
      <div class="test_url">Test URLs</div>
      <div>
        <div class="test_url-content">
          To start the test,copy a URL and paste inside a web browser
        </div>
        <div class="url-container">
          <div
            class="url-content"
            *ngIf="setupService.clientToAgentInfo.activeLicense !== 'fat-engine'"
          >
            <div class="url-title">
              {{
                setupService.clientToAgentInfo.activeLicense === 'thin-engine'
                  ? 'TrueSpeed Light Client'
                  : 'TrueSpeed Light & Advanced Client'
              }}
            </div>
            <div
              *ngIf="setupService.clientToAgentInfo.dmzURL"
              class="dmz_url"
              (click)="copyDMZURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.dmzServerUrl"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>DMZ Test Link</span>
            </div>
            <div
              *ngIf="setupService.clientToAgentInfo.vtaURL"
              class="vTA_url"
              (click)="copyvTAURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.secondaryTestURL"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>{{ getAgentURLLabel() }}</span>
            </div>
          </div>
          <div class="url-content">
            <div class="url-title">TrueSpeed Advanced Client</div>
            <div
              *ngIf="setupService.clientToAgentInfo.dmzURL"
              class="dmz_url"
              (click)="copyDMZURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.dmzServerUrlAdvanced"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>DMZ Test Link</span>
            </div>
            <div
              *ngIf="setupService.clientToAgentInfo.vtaURL"
              class="vTA_url"
              (click)="copyvTAURL()"
              [cdkCopyToClipboard]="setupService.clientToAgentInfo.secondaryTestURLAdvanced"
            >
              <i class="mdi mdi-content-copy"></i>
              <span>{{ getAgentURLLabel() }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
